import api from "./axios";

// Advisor marketplace API — Phase 1 onboarding + Phase 2 authoring.
// Phase 3 will add /api/marketplace/* fetchers and subscription endpoints
// to this same module (or a sibling marketplaceApi.js — TBD).

// --- Phase 1: onboarding -------------------------------------------------

export const becomeAdvisor = async ({ display_name, jurisdiction = "" }) => {
  const res = await api.post("/api/advisor/become/", {
    display_name,
    jurisdiction,
  });
  return res.data;
};

// --- Phase 2: profile editing -------------------------------------------

export const getAdvisorProfile = async () => {
  const res = await api.get("/api/advisor/profile/");
  return res.data;
};

export const updateAdvisorProfile = async (patch) => {
  const res = await api.patch("/api/advisor/profile/", patch);
  return res.data;
};

// --- Phase 2: skills CRUD -----------------------------------------------

export const listMySkills = async () => {
  const res = await api.get("/api/advisor/skills/");
  return res.data;
};

export const createSkill = async (payload) => {
  const res = await api.post("/api/advisor/skills/", payload);
  return res.data;
};

export const getSkill = async (id) => {
  const res = await api.get(`/api/advisor/skills/${id}/`);
  return res.data;
};

export const updateSkill = async (id, patch) => {
  const res = await api.patch(`/api/advisor/skills/${id}/`, patch);
  return res.data;
};

export const deleteSkill = async (id) => {
  const res = await api.delete(`/api/advisor/skills/${id}/`);
  return res.data;
};

export const submitSkill = async (id) => {
  const res = await api.post(`/api/advisor/skills/${id}/submit/`);
  return res.data;
};

// --- Phase 2: plans CRUD ------------------------------------------------

export const listMyPlans = async () => {
  const res = await api.get("/api/advisor/plans/");
  return res.data;
};

export const createPlan = async (payload) => {
  const res = await api.post("/api/advisor/plans/", payload);
  return res.data;
};

export const getPlan = async (id) => {
  const res = await api.get(`/api/advisor/plans/${id}/`);
  return res.data;
};

export const updatePlan = async (id, patch) => {
  const res = await api.patch(`/api/advisor/plans/${id}/`, patch);
  return res.data;
};

export const deletePlan = async (id) => {
  const res = await api.delete(`/api/advisor/plans/${id}/`);
  return res.data;
};

export const submitPlan = async (id) => {
  const res = await api.post(`/api/advisor/plans/${id}/submit/`);
  return res.data;
};
